<template>
  <div id="app"> 
  <Tab v-for="el in navEls" :name="el" v-bind:key="el" @clicked="tabclicked" />
  <h1>Welcome to my Portfolio</h1>
  <div class="screen" ref="screen">
    <div class="innerContainer">
      <Moon />
      <Star v-for="star in stars" :key="star.id" :properties="star" />
      <UFO v-if="false" />
      <Bldg v-for="bldg in Bldgs" :key="bldg.id" :properties="bldg" />
      <Content v-if="tabSelected != ''" :content="content[tabSelected]" @close="closeContent" />
    </div>
  </div>
  </div>
</template>

<script>
import math from './components/mixins/math'
import Tab from './components/tab.vue'
import UFO from './components/ufo.vue'
import Bldg from './components/bldg.vue'
import Moon from './components/moon.vue'
import Star from './components/star.vue'
import Content from './components/content.vue'
export default {
  name: 'app',
  mixins: [math],
  components: {
    Tab,
    Bldg,
    Moon,
    Star,
    UFO,
    Content
  },
  computed: {
    stars: function(){
      var starsList = [];
      for (let i = 0; i<90; i++) {
        if (i > 5)
        starsList.push({id: 'S'+i, leftMargin: this.randomRange(10,1300), topMargin: this.randomRange(10,150), twinkle: false});
        else
        starsList.push({id: 'S'+i, leftMargin: this.randomRange(10,1300), topMargin: this.randomRange(10,150), twinkle: true});
        }
       return starsList;
    },
    Bldgs: function(){
      var range = [];
      for(let i = 0; i < 20; i++) range.push({id: 'B'+i, leftMargin: this.randomRange(0,30), width: this.randomRange(40,60),
      height: this.randomRange(50,150), radius: this.randomRange(0,15)});
      return range;
    },
    scrWidth: function(){
      if(typeof this.$refs['screen'] !== 'undefined')
      return this.$refs['screen'].offsetWidth;
      else return 0;
    }
  },
  data: function(){
    return{
      navEls: ["Skills","Experiences","Projects","About","Contact"],
      tabSelected: "",
      content: {Skills: {
                  Title: "Skills",
                  Data: {
                    Skills: ['PHP','JavaScript','Laravel','VueJS'],
                  },
                  Component: ''
                },
                Experiences: {
                  Title: "Job Experiences",
                  Data: {},
                  Component: ''
                },
                Projects: {
                  Title: "Projects",
                  Data: {},
                  Component: ''
                },
                About: {
                  Title: "About",
                  Data: {},
                  Component: ''
                },
                Contact: {
                  Title: "Contact Form",
                  Data: {},
                  Component: ''
                },
                }
    }
  },
  methods: {
  tabclicked: function(tab) {
      this.tabSelected = tab;
    },
  closeContent: function(){
      this.tabSelected = "";
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #579fbb;
  background-color: rgb(20, 2, 88);
  margin-top: 20px;
  margin-left: 60px;
  margin-right: 60px;
  padding: 10px;
}
#nav{
  align-self: baseline;
}
h1 {
  font-size: 150%;
  margin: 20px;
}
body {
  background-color: rgb(20, 2, 88);
}
.screen{
  margin: 20px;
  height: 400px;
  margin-bottom: 20px;
  background-color: rgb(6, 2, 68);
  border: 1px solid;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
}
.innerContainer{
  position: relative;
  height: 380px;
}
</style>
